import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-774f4f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 100 80",
  width: "40",
  height: "40",
  id: "hamburger"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "100",
    height: "2"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    y: "30",
    width: "100",
    height: "2"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    "aria-expanded": _ctx.ariaExpanded,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
    type: "button",
    "aria-controls": "navigation"
  }, _hoisted_3, 8, _hoisted_1))
}